import React from 'react';

const ValidationFeedback = ({ validationInfo, validationWarning, validationError }) => {
    return (
        <div className='s4g-validation-wrapper'>
            {validationInfo && validationInfo !== '' &&
                <div className='s4g-section validationInfo'>
                    <span>{validationInfo}</span>
                </div>
            }
            {validationWarning && validationWarning !== '' &&
                <div className='s4g-section validationWarning'>
                    <span>{validationWarning}</span>
                </div>
            }
            {validationError && validationError !== '' &&
                <div className='s4g-section validationError'>
                    <span>{validationError}</span>
                </div>
            }
        </div>
    );
}

export default ValidationFeedback;
